"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthorizedPage = NotAuthorizedPage;
const react_1 = __importDefault(require("react"));
const ErrorPage_1 = require("./ErrorPage");
const react_i18next_1 = require("react-i18next");
function NotAuthorizedPage({ t, tReady }) {
    return (react_1.default.createElement(ErrorPage_1.ErrorPage, { headerText: t('notAuthorizedHeader'), buttonText: t('notAuthorizedButton'), tReady: tReady, t: t }));
}
exports.default = (0, react_i18next_1.withTranslation)('ErrorPage')(NotAuthorizedPage);
